export default "__VITE_ASSET__c4SLUDKg__"